export default __webpack_public_path__ + "static/media/noStore.b5673db6.png";